import React, { useEffect } from "react" ;
import { Switch, Route } from 'react-router-dom';
import { useRecoilState } from 'recoil';

import { Globals, getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getChildDetails } from "root/DataFunctions/ChildDataFns";
import { getMyTheme } from "root/DataFunctions/ChildDataFns";
import { childThemeState } from 'root/recoil/childThemeState';
import { childDetailsState } from 'root/recoil/childDetailsState';

import Main from "./Layout/Main";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import ThemeDrawer from "./Components/ThemeDrawer";

import './styles/App.scss';
import './styles/breadcrumb.scss';

const ChildApplicationComponent = (props) => {
    const [childTheme, setChildTheme] = useRecoilState(childThemeState);
    const [childDetails, setChildDetails] = useRecoilState(childDetailsState);

    const themeImagesPath = Globals.BaseURL + "/images/themes/" + childTheme.background;
    
    useEffect(() => {
        getMyTheme(response =>
        {
            setChildTheme(getDataFromResponse(response)[0]);
        });
    }, []);

    useEffect(() => {
        getChildDetails("me", (response) =>
        {
            setChildDetails(getDataFromResponse(response));
        });
    }, []);
    
    return (
        <div 
            className="child-wrapper"
            style={ childTheme ? { backgroundImage: `url(${themeImagesPath})` } : {} }
        >
            <Navbar />
            <div className="child-main">
                <div className="child-body">
                    <Switch>
                        <Route path="/child" component={Main} />
                        {/* Add 404 page  */}
                    </Switch>
                </div>
                <Footer />
            </div>
            <ThemeDrawer />
        </div>
    );
}

export default ChildApplicationComponent;
